

import {
    Component,
    OnInit,
  } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { arrayUnion, updateDoc } from "firebase/firestore";
import { deleteObject, getStorage, listAll, ref } from "firebase/storage";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { environment } from "src/environments/environment";

  

@Component({
    selector: "app-carica-file-fase2",
    templateUrl: "./dialog-carica_file_fase2.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogCaricaFileFase2 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected tipoFile:String="";
    
    protected file: File;
    protected files: File[]=[];
    protected isUploadingFile:boolean = false;
    
    protected label:string="Cerca file ";
    protected icona:string="";
    protected stile:string="btn-choose-file-fase2";
    protected fileClass:string="btn-choose-file-fase2";
    protected acceptedFileTypes:string=".jpg, .png, .jpeg, .tiff, .gif, .pdf";

    private collection_pratiche:string = environment.firebase.collection_pratiche;


    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      public firestore: AngularFirestore,
    ) {
      this.pratica          = this.config.data.pratica;
      this.tipoFile         = this.config.data.tipoFile;
      if(this.tipoFile==='PING TEST'){
        this.label+=this.tipoFile  ;
      }else if(this.tipoFile==='SPEED TEST'){
        this.label+=this.tipoFile  ;
      }
      
      
    }
  
    ngOnInit(): void {
    }

    onFileUpload($event){

    }

    onFileSelect($event: { files: File[]; }) {
      if(this.tipoFile==='PING TEST'){
        if($event.files.length == 1){
          this.label = 'File del PING TEST caricato';
        }else{
          this.label = $event.files.length + ' file del PING TEST caricati';
        }
        
      }else if(this.tipoFile==='SPEED TEST'){
        if($event.files.length == 1){
          this.label = 'File dello SPEED TEST caricato';
        }else{
          this.label = $event.files.length + ' file del dello SPEED TEST caricati';
        }
       
      }
     
      this.icona = "pi pi-check";
      this.fileClass = "btn-file-fase2-upload-success";
      this.file = $event.files[0];
      this.files = Array.from($event.files); // oppure [...this.files]
     
    }  

    async checkIfFileAlreadyUploaded(tipoFile:string){
      const storage = getStorage();
      const pathReferenceFileFase2    = ref(  storage, "pratiche/scuola/" +  this.pratica.cui + "/IN/FASE_2/file/" );
      try {
        const listResultFileFase2 = await listAll(pathReferenceFileFase2);
    
        if (listResultFileFase2.items.length > 0) {
          const deletePromises: Promise<void>[] = [];
    
          for (const item of listResultFileFase2.items) {
            if (item.name.includes(tipoFile)) {
              this.logger.info(`FILE ${tipoFile} GIA' PRESENTE: ${item.name}, eliminazione in corso...`);
              const fileRef = ref(storage, item.fullPath);
              deletePromises.push(deleteObject(fileRef));
            }
          }
    
          await Promise.all(deletePromises);
          this.logger.info(`Tutti i file con tipo '${tipoFile}' sono stati eliminati.`);
        } else {
          this.logger.info("Nessun file trovato per la rimozione.");
        }
      } catch (error) {
        this.logger.error("Errore durante la verifica e l'eliminazione dei file:", error);
      }
        /* const listResultFileFase2= await listAll(pathReferenceFileFase2);
        if(listResultFileFase2.items.length > 0){
          listResultFileFase2.items.forEach((item) => {
            if(item.name.includes(tipoFile)){
              this.logger.info("FILE " + tipoFile+ " GIA' PRESENTE " + item.name);
            }
            
          });
        } */
    }
   
    async conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {

          this.isUploadingFile = true;
          let contatoreFile:number = 0;
          let contatoreFileCaricati:number = 0;
           if(this.tipoFile==='PING TEST'){
            if(this.pratica.numeroFilePingtestUploaded && this.pratica.numeroFilePingtestUploaded > 0){
              contatoreFile = this.pratica.numeroFilePingtestUploaded ;
            }
          }else if(this.tipoFile==='SPEED TEST'){
            if(this.pratica.numeroFileSpeedtestUploaded && this.pratica.numeroFileSpeedtestUploaded > 0){
              contatoreFile = this.pratica.numeroFileSpeedtestUploaded ;
            }
          } 
          /* this.googleStorageService.listFiles(directoryPath, filePrefix).then(existingFiles => {
            const deletePromises = existingFiles.map(file => this.googleStorageService.deleteFile(file));
          
            Promise.all(deletePromises).then(() => {
              console.log('File esistenti eliminati con successo.');
          
              const fileUploadPromises: Promise<any>[] = [];
          
              for (let index = 0; index < this.files.length; index++) {
                contatoreFile++;
                const file = this.files[index];
                const fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1);
                const fileName = `${directoryPath}${filePrefix}${contatoreFile}.${fileExtension}`;
          
                const fileUploadPromise = this.googleStorageService.uploadFileScuolaToGoogleStorage(file, fileName);
                fileUploadPromises.push(fileUploadPromise);
                contatoreFileCaricati++;
              }
          
              Promise.all(fileUploadPromises)
                .then(() => console.log('Tutti i file caricati con successo'))
                .catch(error => console.error('Errore durante il caricamento dei file:', error));
            }).catch(error => console.error('Errore durante l\'eliminazione dei file:', error));
          }); */
           const fileUploadPromises: Promise<any>[] = [];
           /* if(this.tipoFile==='PING TEST'){
            this.checkIfFileAlreadyUploaded("PING_TEST");
           }else if(this.tipoFile==='SPEED TEST'){
              this.checkIfFileAlreadyUploaded("SPEED_TEST");
            } */
          for (let index = 0; index < this.files.length; index++) {
            contatoreFile+=1;
            const file = this.files[index];
            const fileExtension = file.name.substring( file.name.lastIndexOf(".") + 1 );
            let fileName        = this.pratica.cui + "/IN/FASE_2/file/";
            if(this.tipoFile==='PING TEST'){
              fileName += "PING_TEST_"+contatoreFile+"."+fileExtension;
              
            }else if(this.tipoFile==='SPEED TEST'){
              fileName += "SPEED_TEST_"+contatoreFile+"."+fileExtension;
             
            }
            
           

            const fileUploadPromise = this.googleStorageService.uploadFileScuolaToGoogleStorage(file, fileName);

            fileUploadPromises.push(fileUploadPromise);
            contatoreFileCaricati++;
            
          } 
         
          Promise.all(fileUploadPromises).then(results => {
            const docRef = this.firestore.collection(this.collection_pratiche).doc(this.pratica.cui);
            if(this.tipoFile==='PING TEST'){
              this.pratica.filePingTestUploaded = true;
              this.pratica.numeroFilePingtestUploaded = contatoreFile;
            }else if(this.tipoFile==='SPEED TEST'){
              this.pratica.fileSpeedTestUploaded = true;
              this.pratica.numeroFileSpeedtestUploaded = contatoreFile;
            }
            docRef.update(this.pratica)
              .then(() => {
                
                this.isUploadingFile = false;
                this.dialogRef.close({ success: true, numeroFileCaricati:contatoreFileCaricati});
              })
              .catch((error) => {
                this.messageService.add({
                  severity: "info",
                  summary: "Errore" , life:10000,
                    detail: "Errore in fase di caricamento dei file di "+this.tipoFile+"!",
                  });
                
                this.dialogRef.close({ success: false });
              });
          }).catch(error => {
            this.dialogRef.close({ success: false });
          }).finally(() => {
            this.isUploadingFile = false;
          });
         
       
      } 
    }
  
  }